export enum BetslipSection {
  upsellSuggestions = "upsellSuggestions",
  priceBoostMultis = "priceBoostMultis",
  bbMulti = "bbMulti",
  betBuilders = "betBuilders",
  oneLineMultiple = "oneLineMultiple",
  multiLinesMultiples = "multiLinesMultiples",
  castBets = "castBets",
  singles = "singles",
  lotteries = "lotteries",
}
